// export const url = 'http://demo-marketin.fidem.am';
// export const urlLink = 'http://demo-marketin.fidem.am';

export const url = "https://api.marketin.am";
export const urlLink = "https://api.marketin.am";
